import * as React from 'react';

import Button from '../Button';
import ResponsiveDialog from '../ResponsiveDialog';

// import Button from '@/Button';
// import ResponsiveDialog from '@/ResponsiveDialog';
import { Palette, Sparkle, Users, Wrench } from 'lucide-react';

interface Feature {
    icon: React.ReactNode;
    // title: string;
    proTitle: string;
    businessTitle: string;
    proDescription: string;
    businessDescription: string;
}

export interface UpgradeModalProps {
    isOpen?: boolean;
    onClose?: (props?: any) => Promise<void> | void;
    planName: string;
    featureTitle: string;
    featureDescription: string;
    basePrice: string;
    additionalSeatPrice: string;
    onSubscribe?: () => void;
    className?: string;
    imageSrc?: string;
    currentInterval: string;
    startingCheckout?: boolean;
    openComparePlans?: () => void;
    rank?: number;
    container?: HTMLElement | ShadowRoot | null;
}

const features: Feature[] = [
    {
        icon: <Users size={20} />,
        proTitle: "Work With Your Team",
        businessTitle: "Workspaces",
        proDescription: "Assign permissions and unlock advanced collaboration tools to speed up delivery.",
        businessDescription: "Expand your workspaces for siloed workflows, custom branding, and more flexibility.",
    },
    {
        icon: <Palette size={20} />,
        proTitle: "White Labelling",
        businessTitle: "Team Management",
        proDescription: "Add your logo, brand color, custom training and more. Showcasing YOU, elevating your authority.",
        businessDescription: "Track user activity across all of your workspaces, giving you complete visibility and control over your team's workflow.",
    },
    {
        icon: <Wrench size={20} />,
        proTitle: "Integrate Your Tools",
        businessTitle: "Priority Support",
        proDescription: "Streamline your workflow with advanced 3rd party integrations. Seamless delivery.",
        businessDescription: "Get first-in-line assistance to ensure your issues and questions are resolved as quickly as possible.",
    }
];


export const UpgradeLockModal: React.FC<UpgradeModalProps> = ({
    isOpen,
    onClose,
    planName,
    featureTitle,
    featureDescription,
    basePrice,
    additionalSeatPrice,
    onSubscribe,
    className = '',
    imageSrc,
    currentInterval,
    startingCheckout,
    openComparePlans,
    rank,
    container
}) => {

    return (
        <ResponsiveDialog.Content container={container} className={`max-w-4xl p-0 gap-0 rounded-[24px] border-border ${className}`}>

            <div className="grid lg:grid-cols-2 gap-0">
                {/* Left side - Image placeholder */}
                <div className="relative overflow-hidden p-3 aspect-video lg:aspect-auto lg:pr-0">
                    <img
                        src={imageSrc}
                        alt={planName}
                        className="w-full h-full rounded-xl object-cover overflow-hidden bg-tertiary object-top"
                    />
                </div>

                {/* Right side - Content */}
                <div className="p-6 lg:p-8 space-y-6">

                    <ResponsiveDialog.Header className='border-b-0 p-0  border-border pb-4'>
                        <ResponsiveDialog.Title className="text-[28px] text-textcolor font-semibold">
                            Upgrade to <span className="text-tertiary relative">{planName}<Sparkle size={16} className='text-tertiary absolute -right-3 top-0' /></span>
                        </ResponsiveDialog.Title>
                        <p className="text-textcolor mt-4 text-sm">
                            <span className='font-bold mr-1'>{featureTitle}:</span>
                            <span className=''>{featureDescription.split('\n').map((line, index) => (
                                <span key={index}>{line}<br /></span>
                            ))}
                            </span>
                        </p>
                    </ResponsiveDialog.Header>

                    {/* Features list */}
                    <div className="space-y-6">
                        {features.map((feature, index) => (
                            <div key={index} className="flex gap-4">
                                <div className="flex-shrink-0 w-12 h-12 border border-border rounded-lg flex items-center justify-center text-textcolor">
                                    {feature.icon}
                                </div>
                                <div className="">
                                    <h3 className="font-medium text-sm text-textcolor">{planName === 'Pro' ? feature.proTitle : feature.businessTitle}</h3>
                                    <p className="text-xs text-gray-600 leading-base dark:text-gray-400">{planName === 'Pro' ? feature.proDescription : feature.businessDescription}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Subscription button and pricing */}
                    <div className="space-y-4">
                        {
                            rank === 4 ?
                                <Button
                                    onClick={() =>
                                        window.open(
                                            'https://atarim.io/book-a-call/?utm_campaign=book-call&utm_content=enterprise-pricing&utm_source=app.atarim.io'
                                        )
                                    }
                                    className="w-full  "
                                    size='sm'
                                    variant='primary'
                                    loading={startingCheckout}
                                    rightIcon={<Sparkle size={16} />}
                                >
                                    Book a call
                                </Button> :
                                <Button
                                    onClick={onSubscribe}
                                    className="w-full  "
                                    size='sm'
                                    variant='primary'
                                    loading={startingCheckout}
                                    rightIcon={<Sparkle size={16} />}
                                >
                                    Subscribe to {planName}
                                </Button>
                        }
                        {
                            rank === 4 ?
                                <div className="text-sm text-textcolor text-left">
                                    You're already on our highest plan! Want to tailor it even further? Book a call with our sales team, and we'll ensure it’s perfectly suited to you.
                                </div> :
                                <div className="text-sm text-textcolor text-left">
                                    <p>{`$${Math.round(Number(basePrice))}`}/{currentInterval === 'year' ? 'month billed yearly' : currentInterval} + {additionalSeatPrice}/ {currentInterval} per additional team seats.</p>
                                    <p>
                                        Free Unlimited Clients & Guests.{' '}
                                        <Button variant='link' size="link" onClick={openComparePlans} >
                                            Compare plans
                                        </Button>
                                    </p>
                                </div>
                        }
                    </div>
                </div>
            </div>
        </ResponsiveDialog.Content>
    );
};